<script setup lang="ts">
</script>
<template>
    <div class="product-delivery-information flex flex-col py-4">
        <div>
            <span class="text-sm" v-html="$t('productDeliveryInformation.deliveryTime')" />
            <FoundationLink :to="$t('productDeliveryInformation.linkDeliveryAndShippingCost')" class="text-sm" target="_blank">
                {{$t('productDeliveryInformation.deliveryCostNotice')}}
            </FoundationLink>
        </div>
        <span class="text-sm">{{$t('productDeliveryInformation.deliveryCostReturns')}}</span>
    </div>
</template>